<div>
	<span>{{pub.get('Publication.publicationType.defaulttext')}}</span>
    <span *ngIf="pub.get('Publication.status.defaulttext')"> | {{pub.get('Publication.status.defaulttext')}}</span>
	<span *ngIf="isQualificationThesis()"> | {{pub.get('Publication.qualificationThesis.longtext')}}</span>
	<span *ngIf="isPublicationPeerReviewed()">{{'fs.res.publication.view.peerReviewed' | hisUi}}</span>
	<span *ngIf="isOpenAccess()">{{'fs.res.publication.view.openAccess' | hisUi}}</span>
</div>

<div>
    <!-- view link -->
    <a class="searchResultListTitle" routerLink="/pub/view/{{pub.get('Publication.id')}}" [queryParams]="getViewlinkQueryParams()" (click)="onBeforeNavigate()">{{pub.get('Publication.title')}}</a>
    
	<span class="elementIdentityIcon">
        <!-- detail view -->
        <a *ngIf="showViewButton"
            routerLink="/pub/view/{{pub.get('Publication.id')}}"
            [queryParams]="getViewlinkQueryParams()"
            hisImage="magnifier_detail" 
            title="{{'common.showOf' | hisUi: pub.get('Publication.title')}}"
            (click)="onBeforeNavigate()">
        </a>
        
		<!-- edit button: 
		     * blue color is intended.
		     * bei den ngIfs muss man aufpassen: Damit bei lazy nachgeladenem pub keine inaktiven edit-Buttons angezeigt werden, brauchen wir
		       bei canEdit ===true bzw. ===false. Aber bei canRequestChange muss es anders sein, weil der Wert auch undefined sein kann.
		 -->
		<ng-container *ngIf="showEditButton && auth.hasAnyArray(moduleOptions.RIGHT_EDIT)">
			<a *ngIf="!disableActionButtons || pub.get('canEdit')===true"
			    routerLink="/pub/edit/{{pub.get('Publication.id')}}"
			    [queryParams]="getEditlinkQueryParams()"
			    [title]="'common.editOf' | hisUi: pub.get('Publication.title')"
                hisImage="pencil_one_color" 
                (click)="onBeforeNavigate()">
            </a>
            <a *ngIf="disableActionButtons && pub.get('canEdit')===false && pub.get('canRequestChange')"
                routerLink="/pub/change-request/{{pub.get('Publication.id')}}"
                [queryParams]="getEditlinkQueryParams()"
                [title]="'common.editOf' | hisUi: pub.get('Publication.title')"
                hisImage="pencil_one_color" 
                (click)="onBeforeNavigate()">
            </a>
			<img *ngIf="disableActionButtons && pub.get('canEdit')===false && !pub.get('canRequestChange')"
			    [title]="'common.editOf' | hisUi: pub.get('Publication.title')"
			    hisImage="pencil_one_color_i" class="inlineicon">
		</ng-container>
		<ng-container *ngIf="customActionButtonsTemplate"
            [ngTemplateOutlet]="customActionButtonsTemplate"
            [ngTemplateOutletContext]="{row: pub}">
        </ng-container>
		<!-- delete button -->
		<ng-container *ngIf="showDeleteButton && auth.hasAnyArray(moduleOptions.RIGHT_DELETE)">
			<button (click)="doDelete()" hisImage="delete" class="icon" [title]="'common.deleteOf' | hisUi: pub.get('Publication.title')" [disabled]="disableActionButtons && !pub.get('canDelete')"></button>
		</ng-container>
	</span>
</div>

<!-- creators list with expand/collapse option -->
<div class="searchResultListDetail" *ngIf="isCreatorTypeEditor()">
    <span *ngIf="getNumberOfCreators() <= 3">{{'fs.res.publication.Publication.editor.detailtext' | hisUi }}:&nbsp;{{getAllCreatorNames()}}</span>
    <ng-container *ngIf="getNumberOfCreators() > 3">
        <ng-container *ngIf="!showAllCreators">
			<span>{{'fs.res.publication.Publication.editor.detailtext' | hisUi }}:&nbsp;{{getFirstCreatorNames()}}</span>
            <button (click)="setShowAllCreators(true)" hisImage="ARROW_DOWN_V" class="icon button-more" [title]="'fs.res.publication.view.showAllEditors' | hisUi"></button>
        </ng-container>
        <ng-container *ngIf="showAllCreators">
            <span>{{'fs.res.publication.Publication.editor.detailtext' | hisUi }}:&nbsp;{{getAllCreatorNames()}}</span>
            <button (click)="setShowAllCreators(false)" hisImage="ARROW_UP_V" class="icon button-more" [title]="'fs.res.publication.view.showLessEditors' | hisUi"></button>
        </ng-container>
    </ng-container>
</div>

<div class="searchResultListDetail" *ngIf="!isCreatorTypeEditor()">
    <span *ngIf="getNumberOfCreators() <= 3">{{getAllCreatorNames()}}</span>
    <ng-container *ngIf="getNumberOfCreators() > 3">
        <ng-container *ngIf="!showAllCreators">
			<span>{{getFirstCreatorNames()}}</span>
            <button (click)="setShowAllCreators(true)" hisImage="ARROW_DOWN_V" class="icon button-more" [title]="'fs.res.publication.view.showAllAuthors' | hisUi"></button>
        </ng-container>
        <ng-container *ngIf="showAllCreators">
            <span>{{getAllCreatorNames()}}</span>
            <button (click)="setShowAllCreators(false)" hisImage="ARROW_UP_V" class="icon button-more" [title]="'fs.res.publication.view.showLessAuthors' | hisUi"></button>
        </ng-container>
    </ng-container>
</div>

<ng-container>
    <!-- #297042 Datum auf Duplikatsseite nicht blau anzeigen -->
    <div [class]="(!prevPage || prevPage !== 'duplicates') ? 'subline' : null">{{'fs.res.finance.project.table.header.publication.releaseYear' | hisUi}}:&nbsp;{{pub.get('Publication.releaseYear')}}</div>
</ng-container>

<div class="searchResultListDetail" *ngIf="prevPage === 'duplicates' && pub.get('Publication.globalIdentifiers')?.length > 0">
    <span>{{pub.get('Publication.globalIdentifiers')}}</span>
</div>
